import DocumentTypes from "../config/documentTypes"
import StringHelper from "./string-helper"

const MaskHelper = {
  date: (format) => {
    let mask = null

    if (format === 'DD/MM/YYYY') {
      mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    } else if (format === 'DD-MM-YYYY') {
      mask = [/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
    } else {
      mask = [/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]
    }

    return mask
  },

  applyDocumentMask: (value, type) => {
    switch (parseInt(type)) {
      case DocumentTypes.CPF:
        return MaskHelper.maskCPF(StringHelper.justNumbers(value))

      case DocumentTypes.CNPJ:
        // CNPJ alfanumérico: base aceita letras e dígitos; mantemos o valor cru
        // e o saneamento acontece dentro de maskCNPJ.
        return MaskHelper.maskCNPJ(value)

      default:
        return value // sem mascara
    }
  },

  maskCPF: (value) => {
    return value
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4')
      .slice(0, 14)
  },

  maskCNPJ: (value) => {
    // CNPJ alfanumérico: os 12 caracteres da base aceitam letras e dígitos;
    // os 2 dígitos verificadores continuam numéricos.
    const cleaned = StringHelper.justAlphanumeric(value).toUpperCase()
    const base = cleaned.slice(0, 12)
    const check = cleaned.slice(12, 14).replace(/[^0-9]/g, '')
    const raw = base + check

    return raw
      .replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2')
      .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3')
      .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3/$4')
      .replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})(\d)/, '$1.$2.$3/$4-$5')
      .slice(0, 18)
  },

  getCPFMaskPattern: () => {
    return [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/
    ]
  },

  getCNPJMaskPattern: () => {
    // Base alfanumérica (12 caracteres) + dígitos verificadores numéricos (2).
    return [
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      '.',
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      '.',
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      '/',
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      /[A-Za-z0-9]/,
      '-',
      /\d/,
      /\d/
    ]
  },

  formatBrazilianPhone: (phone) => {

    if (!phone) return '';

    // remove tudo que não for número
    const digits = phone.replace(/\D/g, '');

    // celular com DDD (11 dígitos)
    if (digits.length === 11) {
      return digits.replace(
        /(\d{2})(\d{5})(\d{4})/,
        '($1) $2-$3'
      );
    }

    // fixo com DDD (10 dígitos)
    if (digits.length === 10) {
      return digits.replace(
        /(\d{2})(\d{4})(\d{4})/,
        '($1) $2-$3'
      );
    }

    // celular sem DDD (9 dígitos)
    if (digits.length === 9) {
      return digits.replace(
        /(\d{5})(\d{4})/,
        '$1-$2'
      );
    }

    // fixo sem DDD (8 dígitos)
    if (digits.length === 8) {
      return digits.replace(
        /(\d{4})(\d{4})/,
        '$1-$2'
      );
    }

    // fallback: devolve como veio
    return phone;
  }
 
}

export default MaskHelper
